import React from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import "./CheckboxGroup.styles.scss";
import FormikControl from "./FormikControl";

function CheckboxGroup(props) {
  const { label, name, options, disabled, ...rest } = props;
  return (
    <>
      <label className="xs-lable-select white">
        {label}
        <span style={{ color: "red" }}>{` *`}</span>
      </label>
      <div className="checkbox_container">
        <Field name={name}>
          {({ field, form: { setFieldValue } }) => {
            return options.map((option) => {
              // console.log(option)
              return (
                <div key={option?.key} className="checkbox_body">
                  <input
                    className="large-checkbox"
                    type="checkbox"
                    id={option?.value}
                    {...field}
                    {...rest}
                    disabled={disabled}
                    value={option?.value}
                    checked={field?.value?.includes(option?.value)}
                    style={{
                      color: `${disabled ? "#707070" : "white"}`,
                      opacity: `${disabled ? "0.4" : "1"}`,
                    }}
                  />
                  <label
                    className={`checkbox_label ${
                      field?.value?.includes(option?.value)
                        ? "active_checkbox"
                        : ""
                    }`}
                    htmlFor={option?.value}
                    style={disabled ? { color: "#707070" } : null}
                  >
                    {option?.key}
                  </label>
                  {option?.key === "Other" && field?.value?.includes("Other") && props?.other !== undefined? (
                    <div className="primary_input" style={{marginTop: "-5px", marginLeft:"10px",marginBottom:"0px",minWidth:"50%"}}>
                    <Field
                    
                  
                      id={props.other}
                     
                      style={disabled ? { color: "#707070" } : null}
                      name={props.other}
                      {...rest}
                    />
                    </div>
                    // <input
                    //   className="other-input"
                    //   type="text"
                    //   //{...field}
                    //   //value={field.value}
                    //   onChange={(e) => {
                    //     console.log(field.value);
                    //     setFieldValue(name, e.target.value);
                    //   }}
                    //   // disabled={present.includes(field.value)}
                    // />
                    
                  ) : null}
                </div>
              );
            });
          }}
        </Field>
      </div>
      <ErrorMessage component={TextError} name={name} />
    </>
  );
}

export default CheckboxGroup;
